// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"513":"76a59343","703":"9f45db8f","787":"7ed16d23"}[chunkId] + ".chunk.js";
};